export default function () {
    function PopupCenter(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        let dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

        let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        let left = ((width / 2) - (w / 2)) + dualScreenLeft;
        let top = ((height / 2) - (h / 2)) + dualScreenTop;
        let newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    }

    function socialShare(name, link, title, img, text) {
        let url;
        switch (name) {
            case 'tw':
                url = 'https://twitter.com/intent/tweet?';
                url += 'text=' + encodeURIComponent(title);
                url += '&url=' + encodeURIComponent(link);
                PopupCenter(url, '', 626, 436);
                break;
            case 'vk':
                url = 'http://vk.com/share.php?';
                url += 'url=' + encodeURIComponent(link);
                url += '&title=' + encodeURIComponent(title);
                url += '&image=' + encodeURIComponent(img);
                url += '&description=' + encodeURIComponent(text);
                url += '&noparse=true';
                PopupCenter(url, '', 626, 436);
                break;
            case 'pin':
                url = 'http://pinterest.com/pin/create/button/?';
                url += 'url=' + encodeURIComponent(link);
                url += '&media=' + encodeURIComponent(img);
                url += '&description=' + encodeURIComponent(title);
                PopupCenter(url, '', 626, 436);
                break;
            case 'gp':
                url = 'https://plus.google.com/share?';
                url += 'url=' + encodeURIComponent(link);
                url += '&title=' + encodeURIComponent(title);
                PopupCenter(url, '', 626, 436);
                break;
            case 'ok':
                url = 'https://connect.ok.ru/offer?';
                url += 'url=' + encodeURIComponent(link);
                url += '&title=' + encodeURIComponent(title);
                url += '&imageUrl=' + encodeURIComponent(img);
                PopupCenter(url, '', 626, 436);
                break;
            case 'tg':
                url = 'https://telegram.me/share/url?';
                url += 'url=' + encodeURIComponent(link);
                url += '&text=' + encodeURIComponent(title);
                PopupCenter(url, '', 626, 436);
                break;
            case 'mail':
                url = 'mailto:?';
                url += 'body=' + encodeURIComponent(link) + '%0A' + encodeURIComponent(text);
                url += '&subject=' + encodeURIComponent(title);
                window.open(url);
                break;
            case 'fb':
                FB.ui({
                        method: 'feed',
                        name: title,
                        link: link,
                        description: text,
                        picture: img
                    }
                );
                break;
        }
    }

    let shareBlock = document.getElementsByClassName('js-share')[0];

    if (shareBlock) {

        let shareLinks = shareBlock.getElementsByTagName('a');

        window.fbAsyncInit = function () {
            FB.init({
                appId: '177434906846007',
                xfbml: true,
                version: 'v4.0'
            });
            FB.AppEvents.logPageView();
        };

        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));


        Array.from(shareLinks).forEach(button => button.addEventListener('click', function(e){

            let name =  this.getAttribute('data-network');
            let link = shareBlock.getAttribute('data-link');
            let title = shareBlock.getAttribute('data-title');
            let img = shareBlock.getAttribute('data-img');
            let text = shareBlock.getAttribute('data-text');
            socialShare(name, link, title, img, text);
            e.preventDefault();

        }));

    }


}
